import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useAppSelector } from '../../redux/hooks';
import { selectDirection } from '../../redux/selectors';

import SanitizedParagraph from '../common/SanitizedParagraph';

interface TextWidgetProps {
    text: string;
}

const TextWidget: React.FC<TextWidgetProps> = ({text}) => {
    
    const direction = useAppSelector(selectDirection)

    return (
        <Box sx={{pr: '1.5em', direction: direction}}>
            <SanitizedParagraph variant={'p'} component={'div'} content={text} />
        </Box>
    );
};

export default TextWidget
